import { render, staticRenderFns } from "./recover-list.vue?vue&type=template&id=3bf655b8&"
import script from "./recover-list.vue?vue&type=script&lang=js&"
export * from "./recover-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports